import useConditionEditor, { conditionSaveError } from './useConditionEditor';
import { selectCondition } from "../../../../utils/conditionSelection";
// Edit authored content with blocking WhatsApp Flow display validation.
import { flowFieldErrors } from "../flowFieldValidation";
import FlowFieldErrors from "../FlowFieldErrors";
// Edit sections and subsections, with advisory Flow title/description budgets.
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
// import { v4 as uuidv4 } from 'uuid';
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import { toast } from "react-toastify";
import { Form, Checkbox, Button, Icon, Divider, Confirm, Segment, Tab } from "semantic-ui-react";
import * as QUESTIONNAIRE_ACTIONS from "../../../../actions/questionaireActions";
import * as SECTION_ACTIONS from "../../../../actions/sectionActions";
import * as CONDITION_ACTIONS from '../../../../actions/conditionActions';
import * as LOOKUPS_ACTIONS from "../../../../actions/lookupsActions";
import { AVAILABLE_TRANSLATION_LANGUAGES as AVAILABLE_LANGUAGES } from "../../../../constants/translations";
import ConditionComponent from "./ConditionComponent";

// Section Name Translations Tab Component
const SectionTranslationsTab = ({ section, updateTranslation, questionaire }) => {
  const selectedLanguages = questionaire?.languages || [];

  return (
    <Segment>
      {selectedLanguages.map((langCode) => {
        const language = AVAILABLE_LANGUAGES.find(lang => lang.value === langCode);
        const languageName = language ? language.text : langCode;

        return (
          <div key={langCode} style={{ marginBottom: '20px' }}>
            <h4>{languageName}</h4>
            <Form.Field>
              <label>Section Name Translation:</label>
              <input
                placeholder={`Enter section name translation for ${languageName}`}
                value={section.translations?.name?.[langCode] || ''}
                onChange={(e) => updateTranslation('name', langCode, e.target.value)}
              />
            </Form.Field>
            <Form.Field>
              <label>Section display name translation:</label>
              <input
                value={section.translations?.displayName?.[langCode] || ''}
                onChange={(e) => updateTranslation('displayName', langCode, e.target.value)}
              />
            </Form.Field>
            <Divider />
          </div>
        );
      })}
    </Segment>
  );
};
export function SectionDetails(props) {
  const [state, setState] = useState({
    questionaire: { ...props.questionaire },
    section: { ...props.section },
    sections: Array.isArray(props.sections) ? props.sections : [],
    showCondition: props.section != null && props.section.isConditional == true,
    showConfirmIsActive: false,
    activeTab: 0,
  });

  useEffect(() => {
    setState(previous => previous.section.id === props.section.id && previous.section.tenantId === props.section.tenantId ? previous : {
      ...previous, section: { ...props.section }, questionaire: { ...props.questionaire },
      showCondition: props.section.isConditional === true, showConfirmIsActive: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.section.id, props.section.tenantId]);

  const conditionEditor = useConditionEditor({ tenantId: props.section.tenantId,
    questionnaireId: props.questionaire[0].id, ownerId: props.section.id, sectionId: props.section.id,
    isSectionCondition: true, isNew: props.isNew, fetchCondition: props.fetchCondition });
  const validateCondition = () => {
    const message = conditionSaveError(conditionEditor, state.section.isConditional === true);
    if (message) toast.error(message);
    return !message;
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
  } = useForm({
    mode: "all",
    reValidateMode: "onBlur",
  });

  const confirmDeactivate = () => {
    let contentMessage = "The questionnaire is currently active or under review. Editing any part of the questionnaire will result in its deactivation, requiring it to undergo the review process again.";

    return (
      <Confirm
        header='Warning:'
        content={contentMessage}
        open={state.showConfirmIsActive}
        onCancel={() => setState((state) => ({ ...state, showConfirmIsActive: false }))}
        onConfirm={() => {
          if (!validateCondition()) return;
          var section = {
            ...state.section,
            sequence: state.section.sequence ?? 1,
          };

          setState((prevState) => ({
            ...prevState,
            section: section,
          }));

          props.deactiveQuestionaireAction(props.questionaire[0]);
          props.commitSection(state.section, conditionEditor.condition, props.isNew, props.section.tenantId);

          if (!_.isEmpty(conditionEditor.condition)) {
            if (state.showCondition === true) {
              conditionEditor.condition.questionnaireId = state.section.questionnaireId;
              conditionEditor.condition.sectionId = state.section.id;
              conditionEditor.condition.questionId = null;
            }
          } else {
            if (state.showCondition === true) {
              props.commitCondition(
                _.omit(conditionEditor.condition, ["isNew"]),
                conditionEditor.condition.isNew === true
              );
            }
          }

          if (_.isEmpty(props.onComplete)) {
            props.onComplete();
          }
        }}
      />
    );
  }

  const flowErrors = flowFieldErrors(state.section, state.questionaire[0], "section");

  const onSubmit = (data) => {
    if (!validateCondition()) return;
    const isQuestionnaireActive = props.questionaire[0].status == "active" || props.questionaire[0].status == "underReview";

    if (isQuestionnaireActive) {
      setState((state) => ({ ...state, showConfirmIsActive: true }));
    } else {

      const newSequence = Number(state.section.sequence);
      const isDuplicate = newSequence !== "" && state.sections.some(section => section.id !== state.section.id && section.sequence === newSequence);

      if (isDuplicate) {
        toast.error("The entered sequence number is already in use.")
      } else {
        var section = {
          ...state.section,
          sequence: state.section.sequence ?? 1,
        };

        setState((prevState) => ({
          ...prevState,
          section: section,
        }));

        props.commitSection(state.section, conditionEditor.condition, props.isNew, props.section.tenantId);

        if (!_.isEmpty(conditionEditor.condition)) {
          if (state.showCondition === true) {
            conditionEditor.condition.questionnaireId = state.section.questionnaireId;
            conditionEditor.condition.sectionId = state.section.id;
            conditionEditor.condition.questionId = null;
          }
        } else {
          if (state.showCondition === true) {
            props.commitCondition(
              _.omit(conditionEditor.condition, ["isNew"]),
              conditionEditor.condition.isNew === true
            );
          }
        }

        if (_.isEmpty(props.onComplete)) {
          props.onComplete();
        }
      }
    }
  };

  const showCondition = () => {
    setState((state) => ({ ...state, section: { ...state.section, isConditional: !state.showCondition ? true : false }, showCondition: !state.showCondition }))
  }

  const handleConditionEdit = conditionEditor.edit;

  const onHandleChange = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      section: {
        ...prevState.section,
        [key]: value,
      },
    }));
  };

  const updateTranslation = (field, language, value) => {
    const translations = state.section.translations || {};
    const fieldTranslations = translations[field] || {};

    setState((prevState) => ({
      ...prevState,
      section: {
        ...prevState.section,
        translations: {
          ...translations,
          [field]: {
            ...fieldTranslations,
            [language]: value
          }
        }
      }
    }));
  };

  // Render form content function
  const renderFormContent = () => (
    <>
      <Form.Field>
        <label>Section Name:</label>
        <input
          className={errors.section_name ? "invalid-input-field" : ""}
          {...register("section_name", { required: true, maxLength: 50, })}
          placeholder="Section Name"
          value={state.section.name}
          onChange={(e) => {
            setState((prevState) => ({
              ...prevState,
              section: { ...prevState.section, name: e.target.value },
            }));
          }}
        />

        {errors.section_name && errors.section_name.type === "required" && (
          <p className="validation-error">* Please enter a name</p>
        )}
        {errors.section_name && errors.section_name.type === "pattern" && (
          <p className="validation-error">
            * May only contain alphabetical characters
          </p>
        )}
        {errors.section_name && errors.section_name.type === "maxLength" && (
          <p className="validation-error">
            * Name may not be more than 50 characters long
          </p>
        )}
      </Form.Field>
      <Form.Field>
        <label>Section Display Name:</label>
        <input
          className={errors.section_display_name ? "invalid-input-field" : ""}
          {...register("section_display_name", {
            required: true,
            maxLength: 50,
          })}
          placeholder="Section Display Name"
          value={state.section.displayName}
          onChange={(e) => {
            setState((prevState) => ({
              ...prevState,
              section: { ...prevState.section, displayName: e.target.value },
            }));
          }}
        />
        {errors.section_display_name &&
          errors.section_display_name.type === "required" && (
            <p className="validation-error">* Please enter a display name</p>
          )}
        {errors.section_display_name &&
          errors.section_display_name.type === "pattern" && (
            <p className="validation-error">
              * May only contain alphabetical characters
            </p>
          )}
        {errors.section_display_name &&
          errors.section_display_name.type === "maxLength" && (
            <p className="validation-error">
              * Name may not be more than 50 characters long
            </p>
          )}
      </Form.Field>
      <Form.Field>
        <label>Extra Info:</label>
        <input
          className={errors.extra_info ? "invalid-input-field" : ""}
          {...register("extra_info", {
            required: false,
            maxLength: 50,
          })}
          placeholder="Extra Info"
          value={state.section.extraInfo}
          onChange={(e) => {
            setState((prevState) => ({
              ...prevState,
              section: { ...prevState.section, extraInfo: e.target.value },
            }));
          }}
        />
        {errors.extra_info && errors.extra_info.type === "required" && (
          <p className="validation-error">* Please enter extra info</p>
        )}
        {errors.extra_info && errors.extra_info.type === "pattern" && (
          <p className="validation-error">
            * May only contain alphabetical characters
          </p>
        )}
        {errors.extra_info && errors.extra_info.type === "maxLength" && (
          <p className="validation-error">
            * Name may not be more than 50 characters long
          </p>
        )}
      </Form.Field>
      <Form.Field>
        <Checkbox
          toggle
          label="Mandatory"
          defaultChecked={!!state.section.isMandatory}
          checked={!!state.section.isMandatory}
          onChange={() => {
            setState((prevState) => ({
              ...prevState,
              section: {
                ...prevState.section,
                isMandatory: !prevState.section.isMandatory,
              },
            }));
          }}
        />
      </Form.Field>
      <Form.Field>
        <Checkbox
          toggle
          label="Is Active"
          defaultChecked={!!state.section.isActive}
          checked={!!state.section.isActive}
          onChange={() => {
            setState((prevState) => ({
              ...prevState,
              section: {
                ...prevState.section,
                isActive: !prevState.section.isActive,
              },
            }));
          }}
        />
      </Form.Field>
      <Form.Field>
        <label>Sequence:</label>
        <input
          placeholder="1"
          type="number"
          min="1"
          max="100"
          value={state.section.sequence}
          onChange={(e) => {
            const value = e.target.value === '' ? 1 : e.target.value;
            setState((prevState) => ({
              ...prevState,
              section: { ...prevState.section, sequence: value },
            }));
          }}
        />
      </Form.Field>
      <Form.Field>
        <Checkbox
          toggle
          label=" Section has condition?"
          defaultChecked={!!state.section.isConditional}
          checked={!!state.section.isConditional}
          onChange={() => {
            setState((prevState) => ({
              ...prevState,
              section: {
                ...prevState.section,
                isConditional: !prevState.section.isConditional,
              },
            }));
            showCondition();
          }}
        />
      </Form.Field>
      {state.showCondition && (
        <ConditionComponent
          targetSectionId={conditionEditor.condition.targetSectionId}
          targetQuestionId={conditionEditor.condition.targetQuestionId}
          questionaire={state.questionaire[0]}
          sectionId={state.section.id}
          isSectionCondition={true}
          condition={conditionEditor.condition}
          loadStatus={conditionEditor.status}
          selectionWarning={conditionEditor.warning}
          onRetry={conditionEditor.retry}
          onConditionEdit={handleConditionEdit}
        />
      )}
    </>
  );

  return (
    <Segment style={{ backgroundColor: 'white', padding: '20px' }}>
      <Form size="small" onSubmit={handleSubmit(onSubmit)} style={{ paddingBottom: "20px" }}>
        <FlowFieldErrors errors={flowErrors} />
        {confirmDeactivate()}

        {state.questionaire[0]?.translateQnaire && !props.isNew ? (
          <Tab
            activeIndex={state.activeTab}
            onTabChange={(e, { activeIndex }) => setState(prev => ({ ...prev, activeTab: activeIndex }))}
            panes={[
              {
                menuItem: 'General',
                render: () => <Tab.Pane>{renderFormContent()}</Tab.Pane>
              },
              {
                menuItem: 'Translations',
                render: () => <Tab.Pane><SectionTranslationsTab section={state.section} updateTranslation={updateTranslation} questionaire={state.questionaire[0]} /></Tab.Pane>
              }
            ]}
          />
        ) : (
          renderFormContent()
        )}

        <Divider />
        <Button.Group floated="right">
          <Button
            className="danger"
            onClick={() => {
              if (_.isEmpty(props.onComplete)) {
                props.onComplete();
              }
            }}
          >
            <Icon name="remove" /> Cancel
          </Button>
          <Button type="submit" className="success">
            <Icon name="checkmark" /> Ok
          </Button>
        </Button.Group>
      </Form>
    </Segment>
  );
}

SectionDetails.defaultProps = {
  section: {},
  questionaireId: 0,
  sectionId: 0,
};

const mapStateToProps = (state, ownProps) => {
  let section = {};
  let condition = {};
  let isNew = false;
  let newSection = {
    name: "",
    displayName: "",
    extraInfo: "",
    isMandatory: false,
    isConditional: false,
    isActive: true,
    canRepeat: false,
    sequence: 1,
    isUserCreated: true,
    questionaireId: ownProps.questionaire.id,
    sectionId: ownProps.section.sectionId,
    tenantId: ownProps.questionaire.tenantId,
  };

  let questionaire = state.questionaires.filter((questionaire) => questionaire.id === ownProps.section.questionaireId || questionaire.id === ownProps.questionaire.id)

  if (!ownProps.section.hasOwnProperty("id")) {
    section = newSection;
    isNew = true;
  } else {
    section = _.isEmpty(state.sections)
      ? newSection
      : Object.values(
        state.sections.filter((section) => section.id === ownProps.section.id)
      )[0];
    isNew = false;
  }

  if (ownProps.section.id != undefined) {
    condition = selectCondition(state.conditions.filter(row => row.sectionId === ownProps.section.id && !row.questionId), section.isConditional === true).condition || {};
    isNew = false;
  }

  return {
    section: section,
    // sections: sections,
    condition: condition,
    isNew: isNew,
    questionaire: questionaire,
    tenant: state.tenantManagement.activeTenant.tenant,
  };
};

export default connect(
  // map state to props
  mapStateToProps,
  // map dispatch to props
  (dispatch, ownProps) => ({
    fetchSectionsAction: (questionaireId) => dispatch(SECTION_ACTIONS.fetchSectionsAction(questionaireId)),
    deactiveQuestionaireAction: (questionaire) => dispatch(QUESTIONNAIRE_ACTIONS.deactiveQuestionaireAction(questionaire)),
    commitSection: (section, condition, isNew, tenantId) => dispatch(SECTION_ACTIONS.sectionSaveAction(section, condition, isNew, tenantId)),
    fetchCondition: (sectionId, tenantId) => dispatch(CONDITION_ACTIONS.fetchConditionsAction(sectionId, tenantId, true)),
    // fetchLookupListAction: () => dispatch(LOOKUPS_ACTIONS.fetchLookupsAction()),
  })
)(SectionDetails);
